// import { VideoGenres } from '@/helper'
import { MyEvents, Utils } from '@/helper'
import StreamService from '@/services/stream'
import VideoBox from '@/components/video_box'
import contentTopHeader from '@/components/contentTopHeader'
import discoverNav from '@/components/discoverNav'
// import VideoDetailBox from '@/components/video_detail_box'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import '../../../static/styles/video.scss'
// import demoVideo from '../../assets/demo-video.mp4'
import logoutModal from '../../views/LogoutModal'
import UserFollowBtn from "@/components/userFollowBtn";
import _ from 'lodash'

export default {
  props: {
    isComp: Boolean,
    listLimit: Number,
  },
  components: {
    VideoBox,
    contentTopHeader,
    discoverNav,
    VueSlickCarousel,
    logoutModal,
    UserFollowBtn,
  },

  data() {
    return {
      slickOptions: {
        infinite:false,
        slidesToShow: 5,
        slidesToScroll: 5,
        dots: false,
        cssEase: 'linear',
        arrows: true,
        rows: 2
      },
      // demoVideo: demoVideo,
      selectedTab: 0,
      activeTab: 0,
      only_follows: false,
      videos: [],
      items_per_page: 1 * 50,
      pagination: {
        current_page: 1,
        total_pages: 0,
      },
      videoGenres: [],
      isPageReady: false,
      tabs: [
        { id: 'trending', title: 'Trending' },
        // { id: 'new', title: 'New Release' },
        // { id: 'popular', title: 'Popular' },
        // { id: 'live', title: 'Live' },
      ],
      selectedVideo: null,
      viewAllVideos: true,
      show_logout_modal: false,
      show_modalCard1: false,
      show_modalCard2: false,
      show_modalCard3: false,
      show_modalCard4: false,
      bgDemoImg: require('../../assets/tile-1.jpeg'),
      spotlightVideoSource: null,
      videoLoading: require('../../assets/loading.gif'),
      buttonHover: false,
      viewAllIconClick: false,
      selectedVideoCategoryName: 'Trending',
    }
  },

  computed: {
    followButtonText() {
      if (this.selectedVideo.user.is_following) {
        return this.buttonHover ? 'Unfollow' : 'Following'
      }
      return 'Follow'
    },
    onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    available_genres() {
      let genres = [{ id: 0, name: 'All' }]
      if (this.currentUser != null) {
        this.videoGenres.forEach((vg) => {
          const g = this._.find(this.$store.state.app.genres, { name: vg })
          genres.push({ id: g.id, name: g.name })
        })
      }
      // const genres = this._.filter(this.$store.state.app.genres, (g) => (VideoGenres.indexOf(g.name) > -1))
      // console.log('available_genres', genres)
      return genres
    },

    selected_genre() {
      const genre =
        this._.find(this.available_genres, { id: this.activeTab }) ||
        this._.find(this.available_genres, { id: 0 })
      // console.log('selected_genre', this.available_genres, genre)
      return genre
    },

    currentUser() {
      return this.$store.state.auth.user
    },
    beforeDestroy() {
      this.$root.$off(MyEvents.USER_FOLLOW, this.setFollowingStatus)
    },
  },

  watch: {
    $route(toPath, fromPath) {
      this.only_follows = toPath.hash.substr(1) === 'follows'
        // console.log('$route', this.only_follows)
      this.setTab(-1)
    },

    selectedVideoCategoryName(newVal, oldVal) {
      if (newVal != oldVal)
        this.pagination.current_page = 1;
    }
  },

  methods: {
    setFollowingStatus(userId, isFollowing) {
      if (this.selectedVideo.user && this.selectedVideo.user.id === userId) {
        this.selectedVideo.user.is_following = isFollowing
      }
    },
    verifyUser() {
      if (this.currentUser) {
        this.$router.push({name: 'VideoShow', params: { videoId: this.selectedVideo.id }})
      } else {
        StreamService.getSpotlightStream(this.selectedVideo.user.id)
          .then((response) => {
            console.log("response", response)
            this.spotlightVideoSource = response.body.mp_channel_1_ep_1_id
            if (this.currentUser == null) {
              this.show_modalCard3 = true
            } else {
              this.show_modalCard4 = true
            }
          })
          .catch((e) => {
            if (this.currentUser == null) {
              this.show_modalCard1 = true
            } else {
              this.show_modalCard2 = true
            }
          })
      }
    },

    repostItem() {
      StreamService.repostStream(this.selectedVideo.id)
      .then((res) => {
        this.$store.dispatch('error/showSuccessToast', [
          'You just added ' + this.selectedVideo.name + ' stream in your collection.',
        ])
      })
      .catch((e) => {
        this.$store.dispatch(
          'error/showErrorToast',
          e.body.errors || [e.body] || [e.body.error]
        )
      })
    },

    isActiveTab(tab) {
      return this.selectedTab === tab
    },

    onTab(tab) {
      if (this.isComp) {
        this.$router.push({name: 'VideoIndex', params: {filter: tab}})
      } else {
        this.selectedTab = tab
        this.filterVideos(tab)
      }
    },

    filterVideos(filter) {
      console.log(filter)
    },

    changeSelectedVideo(video) {
      this.selectedVideo = video
    },

    displayAllVideos(categoryType) {
      this.selectedVideoCategoryName = categoryType
      this.viewAllVideos = true
    },

    back(){
      this.viewAllVideos = false
      this.loadData(this.activeTab, this.pagination.current_page)
    },

    loadData(tab, page) {
      this.busy = true
      this.$store.dispatch('error/showLoadingActivity', true)
      const params = {
        genre_id: tab,
        only_follows: this.only_follows,
        page: page,
        per_page: this.items_per_page,
      }

      const api_response = this.currentUser != null ? StreamService.getStreams(params) : StreamService.getStreamsPublicUsers(params)
      api_response.then((response) => {
        this.videos = this.videos.concat(response.body.streams)

        this.selectedVideo = this.videos[0]
        this.isPageReady = true
        this.$parent.$el.classList.remove('loading')
        // this.videos.filter((v) => )
        // this.videos = [ ...this.videos, ...this.videos]
        console.log(this.videos)
        this.pagination = response.body.pagination
        this.videoGenres = response.body.genres
        this.$store.dispatch('error/showLoadingActivity', false)
        this.busy = false
      })
      .catch(() => {
        this.$store.dispatch('error/showLoadingActivity', false)
        this.busy = false
      })
    },

    loadMore() {
      this.loadData(this.pagination.current_page + 1)
    },

    setTab(tab) {
      if (this.activeTab !== tab) {
        this.activeTab = tab < 0 ? 0 : tab
        this.videos.length = 0
        this.pagination.current_page = 0
        this.loadData(this.activeTab, this.pagination.current_page)
      }
    },

    loadMoreOnScroll: _.debounce(function (e) {
      this.loadMore();
    }, 500),

    handleScroll(e) {
      let element = e.target;
      let scrollTop = element.scrollTop
      let halfScrollHeight = element.scrollHeight/2
      let gapHeight = halfScrollHeight + 200
      if(scrollTop >= halfScrollHeight && scrollTop <= gapHeight) {
        this.loadMoreOnScroll();
      }
    },

  },

  created() {
    this.$root.$on(MyEvents.USER_FOLLOW, this.setFollowingStatus)

    const paramFilter = this.$route.params.filter || ''

    this.$store.dispatch('navigator/goNextState', { page: 'video', tab: '' })
    this.loadData(this.activeTab, this.pagination.current_page)

    if (paramFilter) {
      this.selectedTab = paramFilter
      this.onTab(this.selectedTab)
    }

  },

  mounted() {
    this.$parent.$el.classList.add("loading")
  },
}



// WEBPACK FOOTER //
// ./src/views/video/index.ctrl.js